import React, { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { Line } from 'react-chartjs-2';
import { useApi } from '~/contexts';
import { colors } from '~/styles';
import { dateFormats } from '~/utils';
import { ChartWrapper, Loading } from './components';

export default function Daily() {
  const api = useApi();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState();

  useEffect(() => {
    const now = moment();
    const end = now.subtract(1, 'day').format(dateFormats.isoDate);
    const start = now.subtract(3, 'months').format(dateFormats.isoDate);
    const getData = async () => {
      setIsLoading(true);
      setData();
      try {
        const { data } = await api.admin.reports.getDailyActiveUsers({ start, end });
        setData(data);
      } finally {
        setIsLoading(false);
      }
    };
    getData();
    return getData.cancel;
  }, [api]);

  const chartData = useMemo(() => {
    if (!data) {
      return null;
    }
    return {
      labels: data.map((item) => item.date),
      datasets: [
        {
          label: 'Users',
          data: data.map((item) => item.count),
          backgroundColor: colors.primary25,
          borderColor: colors.primary,
          fill: true,
          tension: 0.4,
        },
      ],
    };
  }, [data]);

  const options = {
    scales: {
      x: {
        type: 'time',
        time: {
          unit: 'week',
          isoWeekday: true,
          displayFormats: {
            week: 'MMM D',
          },
        },
      },

      y: {
        ticks: {
          precision: 0,
        },
      },
    },
    plugins: {
      title: {
        display: true,
        text: 'Daily Activity (3 months)',
      },
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: ([tooltip]) => moment(tooltip.parsed.x).format('dddd, MMMM D, YYYY'),
        },
      },
    },
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <ChartWrapper>
      <Line data={chartData} options={options} />
    </ChartWrapper>
  );
}
